import { render, staticRenderFns } from "./DashAsideLeft.vue?vue&type=template&id=3576d971&scoped=true&"
import script from "./DashAsideLeft.vue?vue&type=script&lang=ts&"
export * from "./DashAsideLeft.vue?vue&type=script&lang=ts&"
import style0 from "./DashAsideLeft.vue?vue&type=style&index=0&id=3576d971&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576d971",
  null
  
)

export default component.exports